const state = {};

const getters = {};

const mutations = {};
const actions = {
  async im_prescription({}, imGroupId) {
    const result = await Fetch.im_prescription({ imGroupId });
    return result?.length ? result[0] : {};
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
